import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Row, Col } from 'antd';
import Translate from 'react-translate-component';
import { withAsyncActions } from 'react-async-client';
import { equals, find, propEq } from 'ramda';
import * as yup from 'yup';

import { postMassStage, postMassStageMenu } from 'actions/asyncActions';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { fullAutoOptions } from 'constants/asyncClient';
import ErrorHTML from 'components/common/form/ErrorHTML';
import MassStageFields from './MassStageFields';
import ListenerField from 'components/common/form/ListenerField';

const isExcluded = equals(21036);

const validationSchema = yup.object().shape({
    idm: yup.number().required(),
    comment: yup.string().when('idm', (idm, schema) => isExcluded(idm) ? schema.required() : schema.nullable().notRequired())
});

@withAsyncActions({
    postMassStageMenu: postMassStageMenu
        .withPayload(({ params: { projectId, keyList }}) => ({
            vacancyId: projectId,
            keyList
        }))
        .withOptions(fullAutoOptions),
    formAction: postMassStage
        .withSuccessHandler(({ close }) => close())
        .withOptions({ resetOnUnmount: true })
})
@withFormWrapper({
    mapPropsToValues: ({ params: { projectId, keyList } }) => ({
        projectId,
        keyList
    }),
    validationSchema,
    mapBeforeSubmit: (values, props) => {
        const { newStage } = find(propEq('idm', values.idm), props.postMassStageMenu.data.menu);

        return newStage ? {
            ...values,
            newStage
        } : values;
    }
})
export default class MassStageModal extends Component {
    static propTypes = {
        modal: PropTypes.object,
        postMassStageMenu: PropTypes.object,
        formAction: PropTypes.object,
        handleSubmit: PropTypes.func
    };

    renderFooter() {
        const { formAction: { meta }, handleSubmit } = this.props;

        return (
            <Row>
                <Col xs={{ span: 16 }} className='alert-inline'>
                    <ErrorHTML meta={meta} />
                </Col>
                <Col xs={{ span: 8 }}>
                    <Button type='blue' onClick={handleSubmit} disabled={meta.pending}>
                        <Translate content='modal_settings.save' />
                    </Button>
                </Col>
            </Row>
        );
    }

    renderTitle = () => {
        return <Translate component='span' content='worksheetMass.changeStage' />;
    }

    render() {
        const { modal, postMassStageMenu } = this.props;

        return (
            <Modal
                {...modal}
                title={this.renderTitle()}
                footer={this.renderFooter()}
            >
                <ListenerField
                    listenFieldName={'idm'}
                >
                    { ({ idm }) => (
                        <MassStageFields
                            menuAction={postMassStageMenu}
                            isExcluded={isExcluded(idm)}
                        />
                    )}
                </ListenerField>
            </Modal>
        );
    }
}
